<template>
  <RevContainer class="bg-surface-default-mid mb-56 md:mb-72">
    <div class="flex flex-col gap-56 pt-56 md:gap-72 md:pt-72">
      <CustomContent v-if="customContentFirst" v-bind="content.customContent" />

      <SuggestedComparisons
        v-if="content.suggestedComparisons?.length > 0"
        :suggested-comparisons="content.suggestedComparisons"
      />

      <FeaturedArticles
        v-if="content.featuredArticles?.length > 0"
        :articles="content.featuredArticles"
      />

      <CustomContent
        v-if="!customContentFirst"
        v-bind="content.customContent"
      />
      <Reassurance />
    </div>
  </RevContainer>
</template>

<script lang="ts" setup>
import type { ModelComparisonCategoryContent } from '@backmarket/http-api/src/api-specs-model-comparison/models/category-content'
import { RevContainer } from '@ds/components/Container'

import CustomContent from '../CustomContent/CustomContent.vue'
import FeaturedArticles from '../FeaturedArticles/FeaturedArticles.vue'
import Reassurance from '../Reassurance/Reassurance.vue'
import SuggestedComparisons from '../SuggestedComparisons/SuggestedComparisons.vue'

defineProps<{
  content: ModelComparisonCategoryContent['content']
  customContentFirst: boolean
}>()
</script>
